import React, { useEffect, useState } from "react";
import DocumentNavbar from "./DocumentNavbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import ReactPaginate from "react-paginate";
import './Table.css';
import Swal from "sweetalert2";
function NewDocumentsEmployee() {
    const ID = Cookies.get("log_id");
    const [documnents,setDocuments] = useState([]);
    const [details,setDetails] = useState([]);
    function NewDocuments() {
        axios.get(`${url.path}/new_documents/${ID}/`)
        .then((res) =>{
            if (res.data.status){
                var docu = res.data.documents;
                var doc = res.data.docs;
                setDocuments([])
                docu.map((i) => {
                    setDocuments((prevState) =>[
                        ...prevState, i
                    ])
                })
                setDetails([])
                doc.map((e) => {
                    setDetails((prevState) =>[
                        ...prevState, e
                    ])
                })
                
            }
        }).catch((err)=>{
          Toast.fire({
            icon:'error',
            title:err
          })
          })
    }
    useEffect(() =>{
        NewDocuments();
    },[])
          const itemsPerPage = 3;
          const [searchTerm, setSearchTerm] = useState("");
          const [currentPage, setCurrentPage] = useState(0);
    
          const filteredData = documnents.filter((item) =>
            item.Company_name.toLowerCase().includes(searchTerm.toLowerCase())
          );
    
          const offset = currentPage * itemsPerPage;
          const currentItems = filteredData.slice(offset, offset + itemsPerPage);
          const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    
          const handlePageClick = ({ selected }) => {
            setCurrentPage(selected);
          };
          function searchTable(){
            var rows = document.querySelectorAll('#documentTable tbody tr');
            var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
            rows.forEach(function(row) {
              var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
              row.style.display = text.includes(val) ? '' : 'none';
            });
          }
        const [selectedCompany, setSelectedCompany] = useState(null);
      const handleOpenModal = (cmp) => {
        setSelectedCompany(cmp);
      };
      const handleCloseModal = () => {
        setSelectedCompany(null);
      };
      const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
      const [status,setStatus] = useState("");
      const [reason,setReason] = useState("");
      const [formdata,setFormdata] = useState({
        d1:null,
        d2:null,
        d3:null,
        d4:null,
        d5:null,
        d6:null,
        d7:null,
        d8:null,
        d9:null,
        d10:null,
        d11:null,
        d12:null
      })
      const handleInputChange = (e) => {
        setFormdata({
          ...formdata,
          [e.target.name]: e.target.checked ? "1" : null,
        });
      };
      function Verify(e) {
        e.preventDefault();
        const dat = {
          Company_name:formdata.d1,
          reg_number:formdata.d2,
          cmp_mail:formdata.d3,
          director_name:formdata.d4,
          director_contact:formdata.d5,
          gst_no:formdata.d6,
          sin_sis:formdata.d7,
          active:formdata.d8,
          iso:formdata.d9,
          industry:formdata.d10,
          indust_stand:formdata.d11,
          employee_perk:formdata.d12,
          status:status,
          reason:reason,
          Id:ID,
          company:selectedCompany.id,
        }
        axios.post(`${url.path}/verify_documents/`,dat)
        .then((res) =>{
          if (res.data.status){
            Toast.fire({
              icon:'success',
              title:'Company'+" "+status
            })
            handleCloseModal();
            NewDocuments();
          }
        }).catch((err)=>{
          Toast.fire({
            icon:'error',
            title:err
          })
        })
      }
    return(
        <>
        <DocumentNavbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>New Documents</h3>
            </center>
            <div className="search-container">
    <input
      type="text"
      placeholder="Search..."
      onKeyUp={searchTable}
      className="search-input"
      id="search"
    />
  </div>
        <div className="table-container">
      <table className="responsive-table" id="documentTable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Name</th>
            <th>Email</th>
            <th>Contact</th>
            <th>File</th>
            <th>Start</th>
          </tr>
        </thead>
        <tbody>
          {details.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.name}</td>
              <td>{i.email}</td>
              <td>{i.contact}</td>
              <td><a href={i.file} target="_blank" download style={{cursor:'pointer'}} rel="noreferrer">File</a></td>
              <td><button type="button" style={{width:'80px',backgroundColor:'gainsboro',borderRadius:'5px'}} onClick={() => handleOpenModal(i)}>Start</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
    {selectedCompany && (
    <div className="modal-overlay" onClick={handleCloseModal}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{ overflowY: "auto" }}
      >
        <button
          className="close-button"
          onClick={handleCloseModal}
        >
          &times;
        </button>
        <h2>Verify</h2>
        <p>Verify Document of {selectedCompany.name}</p>
        <form onSubmit={Verify}>
          <div className="form-container">
            <div className="form-group-row">
              <div className="form-group">
                <label style={{fontSize:'15px'}}>Company Name:</label>
                <input type="checkbox"  onChange={handleInputChange} name="d1" />
              </div>
              <div className="form-group">
                <label style={{fontSize:'15px'}}>Reg Number:</label>
                <input type="checkbox" onChange={handleInputChange} name="d2" />
              </div>
              <div className="form-group">
                <label style={{fontSize:'15px'}}>Company Email:</label>
                <input type="checkbox" onChange={handleInputChange} name="d3" />
              </div>
            </div>
            <div className="form-group-row">
              <div className="form-group">
                <label style={{fontSize:'15px'}}>Director Name:</label>
                <input type="checkbox" onChange={handleInputChange} name="d4" />
              </div>
              <div className="form-group">
                <label style={{fontSize:'15px'}}>Director Number:</label>
                <input type="checkbox" onChange={handleInputChange} name="d5" />
              </div>
              <div className="form-group">
                <label style={{fontSize:'15px'}}>GST Number:</label>
                <input type="checkbox" onChange={handleInputChange} name="d6" />
              </div>
            </div><div className="form-group-row">
              <div className="form-group">
                <label style={{fontSize:'15px'}}>SIN/SIS Number:</label>
                <input type="checkbox" onChange={handleInputChange} name="d7" />
              </div>
              <div className="form-group">
                <label style={{fontSize:'15px'}}>Active Hiring:</label>
                <input type="checkbox" onChange={handleInputChange} name="d8" />
              </div>
              <div className="form-group">
                <label style={{fontSize:'15px'}}>ISO Marked:</label>
                <input type="checkbox" onChange={handleInputChange} name="d9" />
              </div>
            </div>
            <div className="form-group-row">
              <div className="form-group">
                <label style={{fontSize:'15px'}}>Industry Approved:</label>
                <input type="checkbox" onChange={handleInputChange} name="d10" />
              </div>
              <div className="form-group">
                <label style={{fontSize:'15px'}}>Industry Standards:</label>
                <input type="checkbox" onChange={handleInputChange} name="d11" />
              </div>
              <div className="form-group">
                <label style={{fontSize:'15px'}}>Employee Perks:</label>
                <input type="checkbox" onChange={handleInputChange} name="d12" />
              </div>
            </div>
            <div className="form-group-row">
              <div className="form-group">
                <label style={{fontSize:'15px'}}>Rejection Reason (if any)</label>
                <input type="text" id="reasoninput" onChange={(e) =>setReason(e.target.value)} />
              </div>
            </div>
          </div>
          <center>
          <button type="submit" style={{width:'100px',backgroundColor:'green',borderRadius:'5px',color:'white'}} onClick={() =>setStatus("Approved")}>Approve</button>
          <button type="submit" style={{width:'100px',backgroundColor:'red',borderRadius:'5px',marginLeft:'5px',color:'white'}} onClick={() =>setStatus("Rejected")}>Reject</button>
          </center>
        </form>
      </div>
    </div>
  )}
        </>
    );
}
export default NewDocumentsEmployee;